import { Box, Typography } from '@mui/material';
import React from 'react'
import { Colors } from '../../../assets/theme/Colors';

const CircularCounter = ({
  showPrimaryColor,
  counter,
  primaryColor = Colors.primaryColor,
  secondaryColor = Colors.appBar.main,
  size = 18,
  fontSize = 12,
}) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: '50%',
      color: Colors.white,
      bgcolor: showPrimaryColor ? primaryColor : secondaryColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      userSelect: 'none',
      flexShrink: 0,
    }}
  >
    <Typography sx={{ fontWeight: 700, fontSize }}>{counter}</Typography>
  </Box>
);

export default CircularCounter;
